export default "__VITE_ASSET__BJKLFi3h__"